import { render, staticRenderFns } from "./QuotationWrapper.vue?vue&type=template&id=53523417&"
import script from "./QuotationWrapper.vue?vue&type=script&lang=js&"
export * from "./QuotationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports